import script from "./HomeCustomerGender.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCustomerGender.vue?vue&type=script&setup=true&lang=js"

import "./HomeCustomerGender.vue?vue&type=style&index=0&id=1886c8ea&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1886c8ea"]])

export default __exports__